import { useEffect } from 'react';
import { siteInfo } from '@/mocks/data';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { WebPageSchema, BreadcrumbListSchema, OrganizationSchema } from '@/components/feature/SEOMeta';

export default function About() {
  const formUrl = 'https://readdy.ai/api/form/d9q141nnahb7382ov4eg';

  useEffect(() => {
    document.title = '关于我们 - 爱情岛亚洲';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', '了解爱情岛亚洲的品牌故事、使命愿景和联系方式。亚洲最具影响力的恋爱真人秀平台，为全亚洲单身男女创造浪漫相遇机会。');
  }, []);

  const breadcrumbItems = [
    { label: '首页', to: '/' },
    { label: '关于我们' },
  ];

  const breadcrumbSchemaItems = [
    { name: '首页', item: 'https://www.aiqingdao.asia/' },
    { name: '关于我们' },
  ];

  const milestones = [
    { year: '2025年1月', title: '项目启动', desc: '爱情岛亚洲项目正式立项，创始团队汇聚来自亚洲各国的电视制作人、编剧和恋爱专家。' },
    { year: '2025年6月', title: '岛屿选址', desc: '经过半年的实地考察，最终选定东南亚一座私人岛屿作为拍摄基地。' },
    { year: '2025年10月', title: '嘉宾招募', desc: '第一季嘉宾招募启动，收到来自全亚洲超过50,000份报名申请。' },
    { year: '2026年3月', title: '正式开拍', desc: '第一季正式开拍，八位嘉宾登上爱情岛，开启浪漫之旅。' },
    { year: '2026年7月', title: '节目首播', desc: '爱情岛亚洲第一季正式首播，首集播放量突破1亿次。' },
    { year: '2026年9月', title: '第二季筹备', desc: '第二季筹备工作启动，预计扩大嘉宾阵容和节目规模。' },
  ];

  const values = [
    { icon: 'ri-heart-line', title: '真实', desc: '我们坚持真实记录，不做假。每一位嘉宾的情感表达和选择都是完全自主的，节目组只负责创造相遇的机会。' },
    { icon: 'ri-global-line', title: '多元', desc: '我们致力于展现亚洲多元文化的美。来自不同国家和文化背景的嘉宾，带来了丰富多彩的恋爱观念和情感表达方式。' },
    { icon: 'ri-star-line', title: '品质', desc: '从拍摄到制作，从画面到音乐，我们追求每一个细节的完美。为观众呈现最优质的视听体验。' },
    { icon: 'ri-shield-check-line', title: '责任', desc: '我们重视每一位参与者的情感安全和隐私保护。专业心理团队全程陪伴，确保嘉宾的身心健康。' },
  ];

  const teamMembers = [
    { name: '张伟', role: '执行制作人', bio: '拥有15年电视制作经验，曾参与多档现象级综艺节目制作。' },
    { name: 'Lisa Chen', role: '创意总监', bio: '新加坡籍创意人，擅长跨文化内容策划，曾服务于多家国际媒体。' },
    { name: '田中雅子', role: '选角导演', bio: '日本资深选角导演，拥有敏锐的人才发掘眼光和丰富的真人秀选角经验。' },
    { name: '朴俊昊', role: '视觉总监', bio: '韩国知名视觉设计师，曾为多个顶级综艺节目打造视觉风格。' },
  ];

  return (
    <>
      <OrganizationSchema />
      <WebPageSchema
        title="关于我们 - 爱情岛亚洲"
        description="了解爱情岛亚洲的品牌故事、使命愿景和联系方式。亚洲最具影响力的恋爱真人秀平台。"
        url="https://www.aiqingdao.asia/about"
      />
      <BreadcrumbListSchema items={breadcrumbSchemaItems} />

      <div className="pt-20 md:pt-24 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb items={breadcrumbItems} />

          <div className="py-10 md:py-14 text-center">
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
              关于爱情岛亚洲
            </h1>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
              {siteInfo.fullDescription}
            </p>
          </div>
        </div>
      </div>

      <section className="py-16 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
            <div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-5">
                品牌故事
              </h2>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                {siteInfo.brandStory}
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                我们的团队由来自中国、日本、韩国、新加坡等多个亚洲国家的专业人士组成，每位成员都带着对爱情和真人秀的深厚热情，共同打造这个独一无二的平台。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                从选角到拍摄，从剪辑到播出，我们始终坚持最高标准。因为我们知道，观众期待看到的不仅是一档节目，更是真实动人的爱情故事。
              </p>
            </div>
            <div className="aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Creative%20team%20of%20diverse%20Asian%20professionals%20working%20on%20TV%20production%20at%20tropical%20beach%20location%2C%20collaborative%20atmosphere%2C%20warm%20natural%20lighting%2C%20cinematic%20documentary%20style%2C%20authentic%20behind%20the%20scenes&width=800&height=600&seq=about-brand-story&orientation=landscape"
                alt="爱情岛亚洲制作团队"
                title="爱情岛亚洲制作团队"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
              使命与愿景
            </h2>
            <p className="text-foreground-600 text-sm max-w-xl mx-auto">
              我们为什么做这件事，以及我们想要去往何方
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
            <div className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/70">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-4">
                <i className="ri-compass-3-line text-xl"></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-950 mb-3">我们的使命</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{siteInfo.mission}</p>
            </div>
            <div className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/70">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-4">
                <i className="ri-eye-line text-xl"></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-950 mb-3">我们的愿景</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{siteInfo.vision}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
              核心价值
            </h2>
            <p className="text-foreground-600 text-sm">驱动我们不断前行的核心理念</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {values.map((v, i) => (
              <div key={i} className="bg-background-50 rounded-lg p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-4">
                  <i className={`${v.icon} text-xl`}></i>
                </div>
                <h3 className="text-sm font-heading font-semibold text-foreground-950 mb-2">{v.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
              发展历程
            </h2>
            <p className="text-foreground-600 text-sm">爱情岛亚洲的成长足迹</p>
          </div>
          <div className="relative max-w-3xl mx-auto">
            <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-px"></div>
            <div className="space-y-8">
              {milestones.map((m, i) => (
                <div key={i} className={`relative flex items-start gap-6 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                  <div className="hidden md:block w-1/2"></div>
                  <div className="absolute left-2.5 md:left-1/2 w-3 h-3 rounded-full bg-accent-500 border-2 border-background-50 -translate-x-1/2 mt-1.5 z-10"></div>
                  <div className="ml-10 md:ml-0 md:w-1/2 bg-background-50 rounded-lg p-5 border border-background-200/70">
                    <span className="text-xs text-accent-500 font-semibold">{m.year}</span>
                    <h3 className="text-sm font-heading font-semibold text-foreground-950 mt-1 mb-1">{m.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{m.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
              核心团队
            </h2>
            <p className="text-foreground-600 text-sm">一群充满热情的专业人士</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {teamMembers.map((m, i) => (
              <div key={i} className="bg-background-50 rounded-lg p-6 border border-background-200/70 text-center">
                <div className="w-16 h-16 mx-auto rounded-full bg-secondary-100 flex items-center justify-center mb-4">
                  <i className="ri-user-line text-2xl text-secondary-500"></i>
                </div>
                <h3 className="text-sm font-heading font-semibold text-foreground-950">{m.name}</h3>
                <p className="text-xs text-primary-500 font-medium mt-1 mb-2">{m.role}</p>
                <p className="text-xs text-foreground-500 leading-relaxed">{m.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-foreground-600 text-sm">我们期待听到你的声音</p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            <div>
              <h3 className="text-base font-heading font-semibold text-foreground-950 mb-5">联系方式</h3>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                    <i className="ri-phone-line"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-800">电话</p>
                    <p className="text-sm text-foreground-500">{siteInfo.contactPhone}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                    <i className="ri-mail-line"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-800">邮箱</p>
                    <p className="text-sm text-foreground-500">{siteInfo.contactEmail}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                    <i className="ri-map-pin-line"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-800">地址</p>
                    <p className="text-sm text-foreground-500">{siteInfo.address}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                    <i className="ri-wechat-line"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-800">微信公众号</p>
                    <p className="text-sm text-foreground-500">{siteInfo.socialMedia.wechat}</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-base font-heading font-semibold text-foreground-950 mb-5">发送消息</h3>
              {formUrl ? (
                <form
                  data-readdy-form=""
                  action={formUrl}
                  method="POST"
                  encType="application/x-www-form-urlencoded"
                  className="space-y-4"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const formData = new FormData(form);
                    const honeypot = (form.querySelector('input[name="company_alt"]') as HTMLInputElement);
                    if (honeypot && honeypot.value.trim()) {
                      const msgEl = form.querySelector('.form-msg');
                      if (msgEl) msgEl.innerHTML = '<span class="text-primary-500">消息已发送，感谢您的来信！</span>';
                      return;
                    }
                    try {
                      const res = await fetch(formUrl, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                      });
                      const text = await res.text();
                      let parsed: Record<string, unknown> = {};
                      try { parsed = JSON.parse(text) as Record<string, unknown>; } catch { /* ignore */ }
                      const msgEl = form.querySelector('.form-msg');
                      if (res.ok && parsed?.code === 'OK') {
                        if (msgEl) msgEl.innerHTML = '<span class="text-green-600">消息已发送！我们会尽快回复您。</span>';
                        form.reset();
                      } else {
                        const errMsg = parsed?.meta?.message || parsed?.message || '发送失败，请稍后重试';
                        if (msgEl) msgEl.innerHTML = `<span class="text-red-500">${errMsg}</span>`;
                      }
                    } catch {
                      const msgEl = form.querySelector('.form-msg');
                      if (msgEl) msgEl.innerHTML = '<span class="text-red-500">网络错误，请稍后重试</span>';
                    }
                  }}
                >
                  <div className="honeypot-wrap">
                    <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                      <input id="contact-name" name="name" type="text" required className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors" placeholder="您的姓名" />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                      <input id="contact-email" name="email" type="email" required className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors" placeholder="your@email.com" />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
                    <input id="contact-subject" name="subject" type="text" required className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors" placeholder="消息主题" />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                    <textarea id="contact-message" name="message" maxLength={500} rows={4} className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none" placeholder="请输入您的留言（500字以内）"></textarea>
                  </div>
                  <button type="submit" className="w-full py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    发送消息
                  </button>
                  <div className="form-msg text-sm text-center mt-2"></div>
                </form>
              ) : (
                <p className="text-foreground-500 text-sm">正在加载联系表单...</p>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}